module.exports = __webpack_public_path__ + "img/Interest-swordboat.4c7f7d0d.svg";